import { fromJS } from "immutable"
import {
  CODE_FETCHING,
  ROLES_ADMIN,
  ROLES_ADMIN_MANDU,
  ROLE_AMBASSADOR,
  ROLE_LEADER,
} from "./constants"
import { validate } from "./functions"
export const SHOWED_FEEDBACK_SURVEY = "SHOWED_FEEDBACK_SURVEY"
export const KEY_USER_ID = "USER_ID"
export const KEY_TRANSFER_USER = "TRANSFER_USER"
export const KEY_USER_PHOTO = "USER_PHOTO"
export const KEY_USER_NAME = "USER_NAME"
export const KEY_USER_EMAIL = "USER_EMAIL"
export const KEY_USER_PASSWORD = "KEY_USER_PASSWORD"
export const KEY_AMBASSADOR_ID = "AMBASSADOR_ID"
export const KEY_EMPLOYEE_ID = "EMPLOYEE_ID"
export const KEY_ACTIVE_ROL = "ACTIVE_ROL"
export const KEY_ACTIVE_ROL_NAME = "ACTIVE_ROL_NAME"
export const KEY_USER_ROLES = "USER_ROLES"
export const KEY_USER_ROLES_TEXT = "USER_ROLES_TEXT"
export const KEY_TOKEN = "TOKEN"
export const KEY_MODULES = "MODULES"
export const KEY_COMPANY_ID = "COMPANY_ID"
export const KEY_COMPANY_NAME = "COMPANY_NAME"
export const KEY_VISMA_PEOPLE_SYNC_ENABLED = "VISMA_PEOPLE_SYNC_ENABLED"
export const KEY_COMPANY_HUBSPOT = "COMPANY_HUBSPOT"
export const KEY_COMPANY_COUNTRY = "COMPANY_COUNTRY"
export const KEY_COMPANY_LOGO = "COMPANY_LOGO"
export const KEY_COMPANY_SUPPORT_CHANNEL = "COMPANY_SUPPORT_CHANNEL"
export const KEY_NAME_COMPANY = "NAME_COMPANY"
export const KEY_TRIAL_ACTIVE = "TRIAL_ACTIVE"
export const KEY_TRIAL_DURATION = "TRIAL_DURATION"
export const KEY_TRIAL_END_DATE = "TRIAL_END_DATE"
export const KEY_TRIAL_MAX_COLLABORATORS = "TRIAL_MAX_COLLABORATORS"
export const KEY_TRIAL_START_DATE = "KEY_TRIAL_START_DATE"
export const KEY_ORGANIZATION_DIVISIONS_FILTER = "ORGANIZATION_DIVISIONS_FILTER"
export const KEY_ORGANIZATION_DIVISIONS_DIVISION_FILTER =
  "ORGANIZATION_DIVISIONS_DIVISION_FILTER"
export const KEY_ORGANIZATION_DIVISIONS_PARENT_FILTER =
  "ORGANIZATION_DIVISIONS_PARENT_FILTER"
export const KEY_ORGANIZATION_DIVISIONS_LEVEL_FILTER =
  "ORGANIZATION_DIVISIONS_LEVEL_FILTER"
export const KEY_ORGANIZATION_DIVISIONS_TEXT_FILTER =
  "ORGANIZATION_DIVISIONS_TEXT_FILTER"
export const KEY_DASHBOARD_BIRTHDAY_CHECK = "DASHBOARD_BIRTHDAY_CHECK"
export const KEY_ORGANIZATION_COLLABORATORS_TEXT_FILTER =
  "ORGANIZATION_COLLABORATORS_TEXT_FILTER"
export const KEY_ORGANIZATION_COLLABORATORS_COLUMNS_FILTER =
  "ORGANIZATION_COLLABORATORS_COLUMNS_FILTER"
export const KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER =
  "ORGANIZATION_COLLABORATORS_DIVISION_FILTER"
export const KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER =
  "ORGANIZATION_COLLABORATORS_SEGMENT_FILTER"
export const KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER =
  "ORGANIZATION_COLLABORATORS_LEADERS_FILTER"
export const KEY_CHECKBOX_EXCLUDE = "CHECKBOX_EXCLUDE"
export const KEY_ISOLATED_METRICS = "ISOLATED_METRICS"
export const KEY_ANONYMITY_LEADERS = "ANONYMITY_LEADERS"
export const KEY_ANONYMITY = "ANONYMITY"
export const KEY_REMEMBER_PASSWORD = "REMEMBER_PASSWORD"
export const KEY_ONBOARDING = "ONBOARDING"
export const KEY_TIMESTAMP_COLLABORATORS_IMPORT =
  "TIMESTAMP_COLLABORATORS_IMPORT"
export const KEY_FIRST_NAME = "FIRST_NAME"
export const KEY_LAST_NAME = "LAST_NAME"
export const KEY_SECOND_LAST_NAME = "SECOND_LAST_NAME"
export const KEY_ORGANIZATION_DEMO = "ORGANIZATION_DEMO"
export const KEY_TWO_FACTOR_AUTH_PENDING = "TWO_FACTOR_AUTH_PENDING"
export const KEY_TEMP_AF = "KEY_TEMP_AF"
export const KEY_LOGIN_LANGUAGE = "LOGIN_LANGUAGE" // 1 = Spanish, 2 = English
export const KEY_FEATURE_FLAGS = "FEATURE_FLAGS"
export const KEY_PDA_IA_ENABLED = "KEY_PDA_IA_ENABLED"
export const KEY_NEW_PDA_IA_NOTIFICATION = "KEY_NEW_PDA_IA_NOTIFICATION"
export const KEY_AI_LIMIT_REACHED = "KEY_AI_LIMIT_REACHED"
const { localStorage, location } = window

export const setItem = (key, value = null, callback = null) => {
  try {
    if (validate.exist(key)) {
      localStorage.setItem(key, value)
      if (validate.exist(callback)) {
        callback()
      }
    }
  } catch (e) {
    console.error(e)
  }
}

export const getItem = (key, defaultValue = null) => {
  try {
    if (validate.exist(key)) {
      const value = localStorage.getItem(key)
      return validate.exist(value) ? value : defaultValue
    }
  } catch (e) {
    return defaultValue
  }
}

export const clearStorage = () => {
  localStorage.clear()
  location.reload()
}

export const loadState = () => {
  try {
    const serializedData = localStorage.getItem("state")
    if (serializedData === null) {
      return undefined // Si no existe el state en el local storage devolvemos undefined para que cargue el state inicial que hayamos definido
    }
    return fromJS(JSON.parse(serializedData)) // Si encontramos con exito nuestro storage lo devolvemos.
  } catch (error) {
    return undefined // Si ocurre algun error, devuelvo undefined para cargar el state inicial.
  }
}
export const saveState = (state) => {
  try {
    const serializedData = JSON.stringify(state.toJS())
    localStorage.setItem("state", serializedData)
  } catch (error) {
    // Acá podemos capturar o crear cualquier log que deseemos en caso de que falle el salvado en el storage.
  }
}


export const LOCAL_PDA_IA_ENABLED = () => {
  const value = getItem(KEY_PDA_IA_ENABLED, "false"); // Valor predeterminado "false" si no hay valor devuelto
  return value === "true"; // Convertir cadena a booleano
};
export const LOCAL_AI_LIMIT_REACHED = () => {
  const value = getItem(KEY_AI_LIMIT_REACHED, "false");
  return value === "true";
};
export const LOCAL_NEW_PDA_IA_NOTIFICATION = () => {
  const value = getItem(KEY_NEW_PDA_IA_NOTIFICATION, "false"); // Valor predeterminado "false" si no hay valor devuelto
  return value === "true"; // Convertir cadena a booleano
}
export const LOCAL_VISMA_PEOPLE_SYNC_ENABLED = () => {
  const value = getItem(KEY_VISMA_PEOPLE_SYNC_ENABLED, "false"); // Valor predeterminado "false" si no hay valor devuelto
  return value === "true"; // Convertir cadena a booleano
}
export const LOCAL_USER_ID = () => getItem(KEY_USER_ID)
export const LOCAL_TRANSFER_USER = () => getItem(KEY_TRANSFER_USER)
export const LOCAL_USER_PHOTO = () => getItem(KEY_USER_PHOTO)
export const LOCAL_USER_NAME = () => getItem(KEY_USER_NAME)
export const LOCAL_USER_EMAIL = () => getItem(KEY_USER_EMAIL)
export const LOCAL_AMBASSADOR_ID = () => getItem(KEY_AMBASSADOR_ID)
export const LOCAL_EMPLOYEE_ID = () => getItem(KEY_EMPLOYEE_ID)
export const LOCAL_ACTIVE_ROL = () => getItem(KEY_ACTIVE_ROL)
export const LOCAL_ACTIVE_ROL_NAME = () => getItem(KEY_ACTIVE_ROL_NAME)
export const LOCAL_USER_ROLES = () => getItem(KEY_USER_ROLES)
export const LOCAL_USER_ROLES_TEXT = () => getItem(KEY_USER_ROLES_TEXT)
export const LOCAL_TOKEN = () => getItem(KEY_TOKEN)
export const LOCAL_MODULES = () => getItem(KEY_MODULES)
export const LOCAL_COMPANY_ID = () => getItem(KEY_COMPANY_ID)
export const LOCAL_COMPANY_NAME = () => getItem(KEY_COMPANY_NAME)
export const LOCAL_COMPANY_HUBSPOT = () => getItem(KEY_COMPANY_HUBSPOT)
export const LOCAL_COMPANY_COUNTRY = () => getItem(KEY_COMPANY_COUNTRY)
export const LOCAL_COMPANY_LOGO = () => getItem(KEY_COMPANY_LOGO)
export const LOCAL_COMPANY_SUPPORT_CHANNEL = () => getItem(KEY_COMPANY_SUPPORT_CHANNEL)
export const LOCAL_NAME_COMPANY = () => getItem(KEY_NAME_COMPANY)
export const LOCAL_TRIAL_ACTIVE = () => getItem(KEY_TRIAL_ACTIVE)
export const LOCAL_TRIAL_DURATION = () => getItem(KEY_TRIAL_DURATION)
export const LOCAL_TRIAL_END_DATE = () => getItem(KEY_TRIAL_END_DATE)
export const LOCAL_TRIAL_MAX_COLLABORATORS = () =>
  getItem(KEY_TRIAL_MAX_COLLABORATORS)
export const LOCAL_TRIAL_START_DATE = () => getItem(KEY_TRIAL_START_DATE)
export const LOCAL_ORGANIZATION_DIVISIONS_FILTER = () =>
  getItem(KEY_ORGANIZATION_DIVISIONS_FILTER)
export const LOCAL_ORGANIZATION_DIVISIONS_DIVISION_FILTER = () =>
  getItem(KEY_ORGANIZATION_DIVISIONS_DIVISION_FILTER)
export const LOCAL_ORGANIZATION_DIVISIONS_PARENT_FILTER = () =>
  getItem(KEY_ORGANIZATION_DIVISIONS_PARENT_FILTER)
export const LOCAL_ORGANIZATION_DIVISIONS_LEVEL_FILTER = () =>
  getItem(KEY_ORGANIZATION_DIVISIONS_LEVEL_FILTER)
export const LOCAL_ORGANIZATION_DIVISIONS_TEXT_FILTER = () =>
  getItem(KEY_ORGANIZATION_DIVISIONS_TEXT_FILTER)
export const LOCAL_DASHBOARD_BIRTHDAY_CHECK = () =>
  getItem(KEY_DASHBOARD_BIRTHDAY_CHECK)
export const LOCAL_ORGANIZATION_COLLABORATORS_TEXT_FILTER = () =>
  getItem(KEY_ORGANIZATION_COLLABORATORS_TEXT_FILTER)
export const LOCAL_ORGANIZATION_COLLABORATORS_COLUMNS_FILTER = () =>
  getItem(KEY_ORGANIZATION_COLLABORATORS_COLUMNS_FILTER)
export const LOCAL_ORGANIZATION_COLLABORATORS_DIVISION_FILTER = () =>
  getItem(KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER)
export const LOCAL_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER = () =>
  getItem(KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER)
export const LOCAL_ORGANIZATION_COLLABORATORS_LEADERS_FILTER = () =>
  getItem(KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER)
export const LOCAL_CHECKBOX_EXCLUDE = () => getItem(KEY_CHECKBOX_EXCLUDE)
export const LOCAL_ISOLATED_METRICS = () => getItem(KEY_ISOLATED_METRICS)
export const LOCAL_ANONYMITY_LEADERS = () => getItem(KEY_ANONYMITY_LEADERS)
export const LOCAL_ANONYMITY = () => getItem(KEY_ANONYMITY)
export const LOCAL_REMEMBER_PASSWORD = () => getItem(KEY_REMEMBER_PASSWORD)
export const LOCAL_ONBOARDING = () => getItem(KEY_ONBOARDING)
export const LOCAL_TIMESTAMP_COLLABORATORS_IMPORT = () =>
  getItem(KEY_TIMESTAMP_COLLABORATORS_IMPORT)
export const LOCAL_FIRST_NAME = () => getItem(KEY_FIRST_NAME)
export const LOCAL_LAST_NAME = () => getItem(KEY_LAST_NAME)
export const LOCAL_SECOND_LAST_NAME = () => getItem(KEY_SECOND_LAST_NAME)
export const LOCAL_TWO_FACTOR_AUTH_PENDING = () =>
  getItem(KEY_TWO_FACTOR_AUTH_PENDING)
export const LOCAL_LOGIN_LANGUAGE = () => getItem(KEY_LOGIN_LANGUAGE,"es") // 1 = Español
export const ORGANIZATION_DEMO = () => getItem(KEY_ORGANIZATION_DEMO)
export const FEATURE_FLAGS = () => getItem(KEY_FEATURE_FLAGS)
export const validateSession = () => () => {
  if (LOCAL_COMPANY_ID && LOCAL_USER_ID && LOCAL_TOKEN) {
    return true
  }

  return false
}

export const removeSession = (status) => {
  if (status === CODE_FETCHING.error.Unauthorized) {
    clearStorage()
  }
}

export const isLeader = () => {
  const roles = JSON.parse(LOCAL_USER_ROLES())
  let leader = roles?.find((item) => +item.id === ROLE_LEADER)

  if (validate.exist(leader) && validate.exist(leader.id)) {
    return true
  }
  return false
}

export const isAmbassador = () => {
  const roles = JSON.parse(LOCAL_USER_ROLES())
  let ambassador = roles?.find((item) => +item.id === ROLE_AMBASSADOR)

  if (validate.exist(ambassador) && validate.exist(ambassador.id)) {
    return true
  }
  return false
}

export const isLeaderActive = () => {
  return [ROLE_LEADER].includes(parseInt(LOCAL_ACTIVE_ROL()))
}

export const isAmbassadorActive = () => {
  return [ROLE_AMBASSADOR].includes(parseInt(LOCAL_ACTIVE_ROL()))
}

export const isAmbassadorOrLeaderActive = () => {
  return [ROLE_AMBASSADOR, ROLE_LEADER].includes(parseInt(LOCAL_ACTIVE_ROL()))
}

export const isAdmin = () => {
  return ROLES_ADMIN.includes(+LOCAL_ACTIVE_ROL())
}

export const hasAdminRole = () => {
  let roles = JSON.parse(LOCAL_USER_ROLES())
  let role = roles.filter((rol) => ROLES_ADMIN.includes(rol.id))
  return role.length !== 0
}

export const isAdminMandu = () => {
  return ROLES_ADMIN_MANDU.includes(+LOCAL_ACTIVE_ROL())
}

export const isModuleBySlug = (slug) => {
  let validateSlug = true
  const modules = JSON.parse(LOCAL_MODULES())
  if (validate.exist(modules) && modules.length > 0) {
    let module = modules.find((row) => row.slug === slug)
    if (validate.exist(module) && validate.exist(module.slug)) {
      validateSlug = module.mode === "enable"
    } else {
      validateSlug = false
    }
  }
  return validateSlug
}

export const isModeInModuleBySlug = (slug) => {
  const modules = JSON.parse(LOCAL_MODULES())
  if (validate.exist(modules) && modules.length > 0) {
    let module = modules.find((row) => row.slug === slug)
    if (validate.exist(module) && validate.exist(module.slug)) {
      return module.mode
    }
  }
  return "enable"
}
